import { tr } from './i18n-core';

export const CONSULTATION_FEE_PATH = 'consultationFee';

export function consultationFeeReason(code: string): string | null {
  if (code === 'no_fee_rule') return tr('opd', 'fee_issue_no_fee_rule');
  if (code === 'no_price') return tr('opd', 'fee_issue_no_price');
  if (code === 'coverage_invalid') return tr('opd', 'fee_issue_coverage_invalid');
  if (code === 'error') return tr('opd', 'fee_issue_error');
  return null;
}

export function consultationFeeReasonFrom(details: readonly { path?: string; message: string }[]): string | null {
  const detail = details.find((entry) => entry.path === CONSULTATION_FEE_PATH);
  return detail ? consultationFeeReason(detail.message) : null;
}
